<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-map-outline"
          inline
          class="px-5 py-4 ml-0"
          title="Regionais"
          elevation="0"
        >
          <v-btn
            id="btn-nova-regional"
            color="accent"
            dark
            class="mt-5"
            style="float:left"
            relative
            medium
            outlined
            @click="$router.push('/administracao/regionais/add')"
          >
            <v-icon left size="30px">
              mdi-plus-circle
            </v-icon>
            Nova Regional
          </v-btn>

          <v-text-field
            id="regionais-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mt-4 break-search bs-regionais"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="regionais-table"
            :headers="headers"
            :items="regionais"
            :search.sync="search"
            :headerProps="{
              sortByText: 'Ordenar Por',
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página',
            }"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            :mobile-breakpoint="800"
            no-data-text="Nenhuma Regional encontrada"
            no-results-text="Nenhuma Regional correspondente encontrado"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id | addLeadingZero }}
            </template>
            <template v-slot:[`item.municipios`]="{ item }">
              <a
                href="javascript:void(0)"
                @click.stop="openMunicipiosDialog(item)"
              >
                {{ item.municipios.length | addLeadingZero }}
              </a>
            </template>
            <template v-slot:[`item.created_by`]="{ item }">
              {{ item.user ? item.user.name : "Sistema" }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | parseToDateTimeBR }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="edit-regionais"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="
                  $router.push(`/administracao/regionais/edit/${item.id}`)
                "
              >
                <v-icon small>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <v-btn
                v-if="item.nome !== 'Distribuidora'"
                id="delete-regionais"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="openDialogDelete(item)"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="municipiosDialog" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="titulo">Municípios</span>
        </v-card-title>
        <v-card-text>
          <v-btn
            color="primary"
            class="mb-2"
            outlined
            :loading="downloadingMunicipios"
            @click="exportarMunicipiosXlsx()"
          >
            <v-icon left>
              mdi-file-excel-outline
            </v-icon>
            Exportar XLSX
          </v-btn>
          <v-data-table
            dense
            :headers="[
              { text: 'Código IBGE', value: 'codigo_municipio' },
              { text: 'Município', value: 'nome_municipio' },
              { text: 'UF', value: 'nome_uf' },
            ]"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [10, 50, 100, 300, -1],
              itemsPerPage: -1,
            }"
            :items-per-page="-1"
            :items="municipiosDialogData"
            no-data-text="Nenhum município listado"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="municipiosDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-delete
      :dialog.sync="dialogDelete"
      @submitTriggered="deleteRegional(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Regional #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a regional
        <strong>{{ dialogDeleteData.nome }}</strong
        >?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import tourMixins from "@/mixins/tourMixins";
  import RegionaisService from "@/services/RegionaisService";
  import MunicipiosService from "@/services/MunicipiosService";

  export default {
    name: "RegionaisIndex",
    mixins: [tourMixins],
    components: {
      DialogDelete: () => import("@/components/general/DialogDelete"),
    },
    data() {
      return {
        headers: [
          {
            text: "#",
            value: "id",
          },
          {
            text: "Nome",
            value: "nome",
          },
          {
            text: "Municípios",
            value: "municipios",
          },
          {
            text: "Criado por",
            value: "created_by",
          },
          {
            text: "Modificado em",
            value: "updated_at",
          },
          {
            sortable: false,
            text: "Ações",
            value: "actions",
            class: "pl-4",
          },
        ],
        regionais: [],
        search: "",
        loading: false,
        arrTour: [
          {
            element: "#btn-nova-regional",
            intro:
              "Clicando neste botão você poderá cadastrar novas Regionais.",
            scrollTo: "tooltip",
            position: "right",
          },
          {
            element: "#regionais-search",
            intro:
              "Neste campo você poderá pesquisar por Regionais já cadastradas.",
            scrollTo: "tooltip",
            position: "bottom",
          },
        ],
        municipiosDialog: false,
        municipiosDialogData: [],
        municipiosDialogNome: "",
        downloadingMunicipios: false,
        dialogDelete: false,
        dialogDeleteData: {
          id: undefined,
          nome: undefined,
        },
      };
    },
    computed: {
      //
    },
    mounted() {
      this.getRegionais();
    },
    methods: {
      getRegionais() {
        this.loading = true;
        this.regionais = [];

        RegionaisService.getAll()
          .then((data) => {
            this.regionais = data;
          })
          .catch((err) => {
            this.$toast.error("Erro ao recuperar Regionais.", "", {
              position: "topRight",
            });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      openDialogDelete(item) {
        this.dialogDeleteData = {
          id: item.id,
          nome: item.nome,
        };
        this.dialogDelete = true;
      },
      deleteRegional(id) {
        this.dialogDelete = false;
        this.dialogDeleteData = {
          id: undefined,
          nome: undefined,
        };

        return RegionaisService.delete(id)
          .then(() => {
            this.$toast.success("Regional excluída com sucesso.", "", {
              position: "topRight",
            });
            this.getRegionais();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao excluir Regional.", "", {
              position: "topRight",
            });
          });
      },
      openMunicipiosDialog(item) {
        this.municipiosDialogData = item.municipios;
        this.municipiosDialogNome = item.nome;
        this.municipiosDialog = true;
      },
      async exportarMunicipiosXlsx() {
        try {
          this.downloadingMunicipios = true;

          const data = await MunicipiosService.downloadXlsx(
            `municipios_${this.municipiosDialogNome}`,
            this.municipiosDialogData,
          );

          const blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `municipios_${this.municipiosDialogNome}.xlsx`;
          a.click();
        } catch (err) {
          console.error(err);
          this.$toast.error("Erro ao exportar municípios.", "", {
            position: "topRight",
          });
        } finally {
          this.downloadingMunicipios = false;
        }
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.importacoes.length
          ? this.arrTour
          : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      },
    },
  };
</script>

<style>
  .titulo {
    font-family: "styrene A";
    font-weight: 500;
    color: #3c4858 !important;
    font-size: 18px !important;
  }

  @media screen and (min-width: 800px) {
    .regionais-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .regionais-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-regionais {
      width: 235.86px !important;
    }
  }
</style>
